import React from 'react';
import { Chip, Stack } from '@mui/material';
import { OmnibarContextFilter } from './utils/context-filter';

interface OmnibarContextFiltersProps {
  currentContextLabel?: string;
  showAdministration?: boolean;
  selected: OmnibarContextFilter;
  onSelect: (filter: OmnibarContextFilter) => void;
}

export function OmnibarContextFilters({ currentContextLabel, showAdministration = false, selected, onSelect }: OmnibarContextFiltersProps) {
  const filters: { value: OmnibarContextFilter; label: string }[] = [
    { value: 'all', label: 'Alt' },
    ...(currentContextLabel ? [{ value: 'current' as const, label: currentContextLabel }] : []),
    { value: 'general', label: 'Generelt' },
    ...(showAdministration ? [{ value: 'administration' as const, label: 'Administration' }] : []),
  ];

  return (
    <Stack direction="row" spacing={1} sx={{ px: 2, pt: 1 }} role="group" aria-label="Filtrér resultater">
      {filters.map(filter => (
        <Chip
          key={filter.value}
          label={filter.label}
          size="small"
          color={selected === filter.value ? 'primary' : 'default'}
          variant={selected === filter.value ? 'filled' : 'outlined'}
          aria-pressed={selected === filter.value}
          // The omnibar closes on blur, so the search field must keep focus.
          onMouseDown={event => event.preventDefault()}
          onClick={() => onSelect(filter.value)}
        />
      ))}
    </Stack>
  );
}
